import React from "react";

import styled from "styled-components";

import "./heading.styles.scss";

interface HeadingProps {
  element: any;
  children: any;
  className: any;
  props?: any;
}

const StyledHeading = styled.span``;

export const Heading = ({
  element = "h1",
  children,
  ...props
}: HeadingProps) => (
  <StyledHeading as={element} {...props}>
    {children}
  </StyledHeading>
);
